<template>
  <div class="text-center">
    <v-menu
      :value="menu"
      @input="$emit('update:menu', $event)"
      :close-on-content-click="false"
      offset-y
      :nudge-right="-10"
    >
      <template v-slot:activator="{ on, attrs }">
        <span class="mr-5" v-bind="attrs" v-on="on"
          ><font-awesome-icon icon="filter" /> Registration Status
        </span>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Ready to Approve"
                value="RequestFinalized"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-divider light></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Request Created"
                value="RequestCreated"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Request Denied"
                value="RequestDenied"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Request Approved"
                value="RequestApproved"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Payment Rejected"
                value="PaymentRejected"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Payment Captured"
                value="PaymentCaptured"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Workflow Completed"
                value="WorkflowCompleted"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox
                v-model="statuses"
                label="Request Cancelled"
                value="RequestCancelled"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="statuses = ['RequestFinalized']">
            Reset
          </v-btn>
          <v-btn color="primary" text @click="$emit('apply')">
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "RequestStatusesSelectMenu",
  props: { menu: Boolean },
  data() {
    return {
      statuses: ["RequestFinalized"]
    }
  },
  watch: {
    statuses() {
      this.$emit('updateStatuses', this.statuses);
    }
  }
});
</script>
